(function() {
  'use strict';

  const headerWrapper = document.querySelector('.section-header .header-wrapper');
  if (!headerWrapper) return;

  const headerSection = headerWrapper.closest('.section-header');
  const schemeLight = headerWrapper.dataset.schemeLight;
  const schemeDark = headerWrapper.dataset.schemeDark;
  if (!schemeLight || !schemeDark) return;

  let sections = [];
  let activeScheme = 'light';
  let ticking = false;
  let isOverlayMode = false;
  let headerHeight = 0;

  const parseRgb = (value) => {
    if (!value) return null;
    const parts = value.trim().split(',').map((p) => Number(p.trim()));
    if (parts.length !== 3 || parts.some((p) => Number.isNaN(p))) return null;
    return parts;
  };

  const relativeLuminance = ([r, g, b]) => {
    const norm = (c) => {
      const n = c / 255;
      return n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * norm(r) + 0.7152 * norm(g) + 0.0722 * norm(b);
  };

  const getSchemeType = (el) => {
    const rgb = parseRgb(getComputedStyle(el).getPropertyValue('--color-background'));
    if (!rgb) return null;
    return relativeLuminance(rgb) >= 0.5 ? 'light' : 'dark';
  };

  const isImageBanner = (section) => {
    if (!section) return false;
    return Boolean(section.querySelector('.banner[id^="Banner-"], .banner__media'));
  };

  // The hero carousel is full-bleed like an image banner, but its tone changes
  // per slide, so it cannot be resolved once at build time the way the others
  // are. It publishes the showing slide's tone on data-active-tone and this
  // stays the single writer of the header's classList.
  const getCarousel = (section) => {
    if (!section) return null;
    return section.querySelector('[data-hero-carousel]');
  };

  const schemeTypeOf = (entry) => {
    if (!entry.carousel) return entry.schemeType;
    return entry.carousel.dataset.activeTone === 'light' ? 'light' : 'dark';
  };

  const buildSections = () => {
    const selector = `.color-${schemeLight}, .color-${schemeDark}`;
    sections = Array.from(document.querySelectorAll('main .shopify-section'))
      .map((section) => {
        const carousel = getCarousel(section);
        if (carousel) {
          return { element: section, carousel };
        }
        // Image banners always dark
        if (isImageBanner(section)) {
          return { element: section, schemeType: 'dark' };
        }
        const schemeEl = section.matches(selector) ? section : section.querySelector(selector);
        if (!schemeEl) return null;
        const schemeType = getSchemeType(schemeEl);
        if (!schemeType) return null;
        return { element: section, schemeType };
      })
      .filter(Boolean);
  };

  const setScheme = (schemeType) => {
    if (schemeType === activeScheme) return;
    const schemeId = schemeType === 'dark' ? schemeDark : schemeLight;
    headerWrapper.classList.remove(`color-${schemeLight}`, `color-${schemeDark}`);
    headerWrapper.classList.add(`color-${schemeId}`);
    headerWrapper.dataset.schemeActive = schemeType;
    activeScheme = schemeType;
  };

  const findActiveSection = () => {
    if (!sections.length) return null;
    let candidate = null;
    for (const s of sections) {
      const rect = s.element.getBoundingClientRect();
      if (rect.bottom <= 0) continue;
      if (rect.top <= headerHeight) candidate = s;
    }
    return candidate;
  };

  const update = () => {
    if (headerWrapper.dataset.menuOpen === 'true') return;

    headerHeight = headerSection ? headerSection.offsetHeight : headerWrapper.offsetHeight;
    
    // Find which section is under the header
    const active = findActiveSection();
    if (active) {
      setScheme(schemeTypeOf(active));
    }

    // Handle transparent background when at top over first image banner
    if (isOverlayMode) {
      const shouldBeTransparent = window.scrollY < 10;
      headerWrapper.classList.toggle('header-wrapper--transparent', shouldBeTransparent);
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  const init = () => {
    // Check if first section is image banner
    const firstSection = document.querySelector('main .shopify-section');
    isOverlayMode = isImageBanner(firstSection) || Boolean(getCarousel(firstSection));
    
    // Set header height CSS variable
    headerHeight = headerSection ? headerSection.offsetHeight : headerWrapper.offsetHeight;
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

    // Build section list
    buildSections();

    // Apply overlay mode if first section is image banner
    document.body.classList.toggle('header-overlay-mode', isOverlayMode);
    
    // If overlay mode, start with dark scheme and transparent background
    if (isOverlayMode) {
      setScheme('dark');
      headerWrapper.classList.add('header-wrapper--transparent');
    }

    update();
  };

  init();
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('hero-carousel:tone', onScroll);
  window.addEventListener('resize', init, { passive: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
